/*** IMPORTS FROM imports-loader ***/
var define = false;

import SmoothScroll from 'smooth-scroll'

const loadSmoothScrolling = () => {
    /* eslint-disable no-new */
    new SmoothScroll('a[href*="#"]', {
        speed: 500,
        offset: 100,
        easing: 'easeInOutCubic'
    })
}

export default loadSmoothScrolling




// WEBPACK FOOTER //
// ./js/smoothScrolling.js